export default __webpack_public_path__ + "static/media/sidebar-compact.f8a0ed76.jpg";